import button, { buttonVariants } from './button';
import heading, { headingVariants } from './heading';
import item, { itemVariants } from './item';
import panel, { panelVariants } from './panel';

const accordion = {
  button,
  heading,
  item,
  panel
};

export const accordionVariants = {
  button: buttonVariants,
  heading: headingVariants,
  item: itemVariants,
  panel: panelVariants
};

export default accordion;
